import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/png/gsalt-black-logo-without-info.png'


const _withScopeId = n => (_pushScopeId("data-v-5e10b264"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "footer-container row" }
const _hoisted_3 = { class: "footer-logo col-md-8 col-12" }
const _hoisted_4 = { class: "text-s" }
const _hoisted_5 = { class: "text-s website-produced-text col-md-4 col-12" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer-divider" }, null, -1))
const _hoisted_7 = { class: "footer-container row" }
const _hoisted_8 = { class: "links col-md-6 col-12 order-md-last" }
const _hoisted_9 = {
  href: "https://www.takeda.com/privacy-notice",
  target: "_blank",
  class: "text-s link"
}
const _hoisted_10 = {
  href: "https://www.takeda.com/terms-of-use",
  target: "_blank",
  class: "text-s link"
}
const _hoisted_11 = {
  href: "https://www.takeda.com/cookie-policy",
  target: "_blank",
  class: "text-s link"
}
const _hoisted_12 = { class: "text-s copyright-text col-md-6 col-12 order-md-first" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { ref } from 'vue'
import ReferencesModal from './ReferencesModal.vue'
import { moduleChoiceLogoReferences } from '@/data/modulechoice'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const referencesModal = ref<InstanceType<typeof ReferencesModal> | null>(null)

  function showReferences() {
  referencesModal.value?.show()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("img", {
            onClick: showReferences,
            class: "logo-gsalt",
            src: _imports_0
          }),
          _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('footer.gsalt')), 1)
        ]),
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('footer.producedByTakeda')), 1)
      ]),
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("a", _hoisted_9, _toDisplayString(_ctx.$t('footer.privacyStatement')), 1),
          _createElementVNode("a", _hoisted_10, _toDisplayString(_ctx.$t('footer.termsOfUse')), 1),
          _createElementVNode("a", _hoisted_11, _toDisplayString(_ctx.$t('footer.cookiePolicy')), 1)
        ]),
        _createElementVNode("p", _hoisted_12, [
          _createTextVNode(_toDisplayString(_ctx.$t('footer.allRightsReserved')), 1),
          _hoisted_13,
          _createTextVNode(" " + _toDisplayString(_ctx.$t('footer.lastUpdated')), 1)
        ])
      ])
    ]),
    _createVNode(ReferencesModal, {
      ref_key: "referencesModal",
      ref: referencesModal,
      references: Object.values(_unref(moduleChoiceLogoReferences))
    }, null, 8, ["references"])
  ], 64))
}
}

})